import { datadogRum } from "@datadog/browser-rum"
import { IS_PROD_ENV } from "./config"

export function initDatadog() {
	if (IS_PROD_ENV) {
		datadogRum.init({
			applicationId: import.meta.env.VITE_DATADOG_APP_ID as string,
			clientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN as string,
			site: "datadoghq.com",
			service: "member-portal-js",
			env: "prod",
			version: "0.1.4",
			sessionSampleRate: 50,
			sessionReplaySampleRate: 20,
			trackUserInteractions: true,
			trackResources: true,
			trackLongTasks: true,
			defaultPrivacyLevel: "mask-user-input",
		})
		console.log("Datadog initialized")
	}
}
